module.exports = "<section>\r\n    <canvas\r\n        baseChart\r\n        [colors] = \"myColors\"\r\n        [chartType]=\"chartType\"\r\n        [datasets]=\"chartData\"\r\n        [labels]=\"chartLabels\"\r\n        [options]=\"chartOptions\"\r\n        [legend]=\"hasLegend\"\r\n        (chartClick)=\"onChartClick($event)\">\r\n    </canvas>\r\n  </section>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/chart/chart.component.html
// module id = ./src/app/shared/chart/chart.component.html
// module chunks = main